module.exports = __webpack_public_path__ + "img/Jubari-website.8b63d6a6.webp";